/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */
import { User } from "../models/User.model";
import { UserData } from "../models/UserData.model";
import { ApiService } from "../services/Api.service";
import { UserDataModification, AdvisorStats } from "../types/RootState";
import { Resource, SingleDocument } from "../utils/json-api";
import { Action } from "../models/Action.model";

/**
 *
 */
export class UserDataApi {
    /**
     *
     */
    constructor(private api: ApiService) {}

    async getForMe(): Promise<UserData> {
        const response = await this.api.get<UserData>(`/user-data/me`);
        const resDoc = response.asSingleDocument();
        return resDoc.getModel();
    }

    async updateUserData(userData: UserData, modifications: UserDataModification[]): Promise<UserData> {
        const reqDoc = new SingleDocument<UserData>()
            .setResource(new Resource<UserData>(UserData.TYPE, userData))
            .setMeta({ modifications });
        const response = await this.api.patch<UserData>(`/user-data/me`, reqDoc);
        const resDoc = response.asSingleDocument();
        if (resDoc.hasError()) {
            throw resDoc.getErrors()[0];
        }
        return resDoc.getModel();
    }

    async statsForAdvisors(advisors: User[]): Promise<{ [userId: string]: AdvisorStats }> {
        const action: Action = {
            id: "advisors-stats",
            params: { usersIds: advisors.map((a) => a.id) },
        };
        const reqDoc = new SingleDocument<Action>().setResource(new Resource<Action>(Action.TYPE, action));
        const response = await this.api.post<Action>(`/user-data/stats`, reqDoc);
        const resDoc = response.asSingleDocument();

        return resDoc.getModel().result.usersStats;
    }
}



// WEBPACK FOOTER //
// ./src/api/UserData.api.ts